import type { PointEvent } from "../../shared/types";
import { timeOfDay } from "../../shared/time";
import { signed } from "../format";
import { Emoji } from "./Emoji";

/** One side of the day in the review ("Good" or "Not so good"): each tap's amount, reason and time. */
export function TapGroup({
  title,
  emoji,
  events,
  empty,
}: {
  title: string;
  emoji: string;
  events: PointEvent[];
  empty: string;
}) {
  return (
    <section className="tap-group">
      <h2 className="tap-group__title">
        <Emoji>{emoji}</Emoji>
        {title}
      </h2>
      {events.length === 0 ? (
        <p className="hint">{empty}</p>
      ) : (
        <ul className="tap-group__list">
          {events.map((e) => (
            <li key={e.id} className="tap-group__item">
              <span className="tap-group__delta">{signed(e.delta)}</span>
              {e.reason && <span className="reason-chip reason-chip--static">{e.reason}</span>}
              <span className="tap-group__time">{timeOfDay(e.at)}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
